import { InjectionToken } from "@angular/core";
import { ISOTService } from "./services/ISOTService";
import { ISOTLanguageService } from "./services/ILanguageService";

export const SOT_SERVICE_INJECTION_TOKEN = new InjectionToken<ISOTService>('SOTService');
export const SOT_LANGUAGE_SERVICE_INJECTION_TOKEN = new InjectionToken<ISOTLanguageService>('SOTLanguageService');